import Component from '@ember/component';

export default class SharedDropZonePreview extends Component {}
